import { createSlice, createSelector } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";
import config from "../../config.json";

const slice = createSlice({
  name: "dashboard",
  initialState: {
    list: [],
    loading: false,
    lastFetch: null,
    wfPhases: [],
    reportData: null,
    reportByMonth: null,
    reportByMonth1: null,
    allAppTasks: [],
    allAppTasksByMonth: [],
    configReport: null,
  },
  reducers: {
    wfPhasesReceived: (dashboard, action) => {
      dashboard.wfPhases = action.payload;
    },
    configReportReceived: (dashboard, action) => {
      dashboard.configReport = action.payload;
    },
    allAppTasksReceived: (dashboard, action) => {
      dashboard.allAppTasks = action.payload;
    },
    allAppTasksByMonthReceived: (dashboard, action) => {
      dashboard.allAppTasksByMonth = action.payload;
    },
    dashboardReportDataReceived: (dashboard, action) => {
      dashboard.reportData = action.payload;
    },
    dashboardReportByMonthReceived: (dashboard, action) => {
      dashboard.reportByMonth = action.payload;
    },
    dashboardReportByMonth1Received: (dashboard, action) => {
      dashboard.reportByMonth1 = action.payload;
    },
  },
});

export const {
  wfPhasesReceived,
  allAppTasksReceived,
  allAppTasksByMonthReceived,
  dashboardReportDataReceived,
  dashboardReportByMonthReceived,
  dashboardReportByMonth1Received,
  configReportReceived,
} = slice.actions;
export default slice.reducer;

export const loadWfPhases = (name) =>
  apiCallBegan({
    url: config.GetCodemanager + name,
    onSuccess: wfPhasesReceived.type,
  });
export const loadDashboardReportData = () =>
  apiCallBegan({
    url: config.GetDashboardData,
    onSuccess: dashboardReportDataReceived.type,
  });

export const loadDashboardReportByMonth = (year) =>
  apiCallBegan({
    url: config.GetReceivedApplicationByMonth + year,
    onSuccess: dashboardReportByMonthReceived.type,
  });

export const loadDashboardReportByMonth1 = (year) =>
  apiCallBegan({
    url: config.GetReceivedApplicationByMonth + year,
    onSuccess: dashboardReportByMonth1Received.type,
  });

export const loadAllAppTasks = (year) =>
  apiCallBegan({
    url: config.GetAllWfTaskStatus + year,
    onSuccess: allAppTasksReceived.type,
  });
export const loadAllAppTasksByMonth = (year) =>
  apiCallBegan({
    url: config.GetAllWfTaskStatusByMonth + year,
    onSuccess: allAppTasksByMonthReceived.type,
  });

export const loadConfigReport = () =>
  apiCallBegan({
    url: config.GetConfigurationReport,
    onSuccess: configReportReceived.type,
  });

export const getWfPhases = createSelector(
  (state) => state.entities.dashboard,
  (dashboard) => dashboard.wfPhases
);

export const getDashboardReportData = createSelector(
  (state) => state.entities.dashboard,
  (dashboard) => dashboard.reportData
);

export const getDashboardReportByMonth = createSelector(
  (state) => state.entities.dashboard,
  (dashboard) => dashboard.reportByMonth
);

export const getDashboardReportByMonth1 = createSelector(
  (state) => state.entities.dashboard,
  (dashboard) => dashboard.reportByMonth1
);

export const getAllAppTasks = createSelector(
  (state) => state.entities.dashboard,
  (dashboard) => dashboard.allAppTasks
);
export const getAllAppTasksByMonth = createSelector(
  (state) => state.entities.dashboard,
  (dashboard) => dashboard.allAppTasksByMonth
);

export const getConfigurationReport = createSelector(
  (state) => state.entities.dashboard,
  (dashboard) => dashboard.configReport
);
